import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "main-content overflow-auto"
};
const _hoisted_2 = { class: "store-adjustment-wrapper" };
const _hoisted_3 = { class: "business-info-wrapper" };
const _hoisted_4 = { class: "mb-6" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BusinessInfo = _resolveComponent("BusinessInfo");
    const _component_StoreAdjustmentHistoryList = _resolveComponent("StoreAdjustmentHistoryList");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    return (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createCommentVNode(" 공급자 정보 "),
                    _createVNode(_component_BusinessInfo, {
                        name: "provider",
                        title: _ctx.$t(`${_ctx.lc}provider_info`),
                        info: _ctx.providerInfo
                    }, null, 8 /* PROPS */, ["title", "info"]),
                    _createCommentVNode(" 공급받는자 정보 "),
                    _createVNode(_component_BusinessInfo, {
                        name: "consumer",
                        title: _ctx.$t(`${_ctx.lc}consumer_info`),
                        info: _ctx.consumerInfo
                    }, null, 8 /* PROPS */, ["title", "info"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_StoreAdjustmentHistoryList)
                ]),
                _createVNode(_component_v_btn, {
                    variant: "outlined",
                    class: "list-btn",
                    onClick: _ctx.handleClickListBtn
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_icon, { small: "" }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createTextVNode(" mdi-chevron-left ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [0]
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.lc + 'back_to_list')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
            ])
        ]))
        : _createCommentVNode("v-if", true);
}
